import { HttpClient } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HelperService } from './helper.service';

@Injectable()
export abstract class BasePollingService implements OnDestroy {

  helper = inject(HelperService);
  http = inject(HttpClient);

  protected pollingSubscription?: Subscription;
  isSubscribed: boolean = false;

  ngOnDestroy() {
    this.isSubscribed = false;
    this.unsubscribePolling();
  }

  unsubscribePolling() {
    this.isSubscribed = false;
    this.pollingSubscription?.unsubscribe();
  }

}
